import React from 'react'

import theme from 'theme_'

export default function HomeIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0006 9.30022V5.00021C19.0006 4.45021 18.5506 4.00021 18.0006 4.00021H17.0006C16.4506 4.00021 16.0006 4.45021 16.0006 5.00021V6.60021L12.6706 3.60021C12.2906 3.26021 11.7106 3.26021 11.3306 3.60021L2.97059 11.1302C2.63059 11.4302 2.84059 12.0002 3.30059 12.0002H5.00059V19.0002C5.00059 19.5502 5.45059 20.0002 6.00059 20.0002H9.00059C9.55059 20.0002 10.0006 19.5502 10.0006 19.0002V14.0002H14.0006V19.0002C14.0006 19.5502 14.4506 20.0002 15.0006 20.0002H18.0006C18.5506 20.0002 19.0006 19.5502 19.0006 19.0002V12.0002H20.7006C21.1606 12.0002 21.3806 11.4302 21.0306 11.1302L19.0006 9.30022ZM10.0006 10.0002C10.0006 8.90022 10.9006 8.00022 12.0006 8.00022C13.1006 8.00022 14.0006 8.90022 14.0006 10.0002H10.0006Z"
        fill={theme.colors.successGreen}
      />
    </svg>
  )
}
